document.addEventListener('DOMContentLoaded', function () {
  const popup     = document.getElementById('SocialProofPopup');
  const dataEl    = document.getElementById('SocialProofData');
  if (!popup || !dataEl) return;

  let items = [];
  try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!items.length) return;

  // ── Config from data attributes ──────────────────────────────────
  const cfg = {
    visibleMs:    (parseFloat(popup.dataset.visibleSeconds)  || 5)  * 1000,
    intervalMs:   (parseFloat(popup.dataset.intervalSeconds) || 12) * 1000,
    initialMs:    (parseFloat(popup.dataset.initialDelay)    || 4)  * 1000,
    loop:         popup.dataset.loop        !== 'false',
    maxCycles:    parseInt(popup.dataset.maxCycles)          || 0,
    shuffle:      popup.dataset.shuffle     !== 'false',
    dynamicTime:  popup.dataset.dynamicTime !== 'false',
    timeMin:      parseInt(popup.dataset.timeMin)            || 2,
    timeMax:      parseInt(popup.dataset.timeMax)            || 59,
    position:     popup.dataset.position                     || 'bottom-left',
  };

  // ── Session: respect user close for this visit ────────────────────
  if (sessionStorage.getItem('sp-closed') === '1') return;

  // ── Position ─────────────────────────────────────────────────────
  const pos = cfg.position;
  const slideOut = pos.endsWith('left') ? 'translateX(-120%)' : 'translateX(120%)';
  popup.style.setProperty('--sp-slide-out', slideOut);

  function applyPosition() {
    const isMobile = window.innerWidth < 768;
    const ox = isMobile ? (parseFloat(popup.dataset.offsetXMobile) || 12) : (parseFloat(popup.dataset.offsetX) || 24);
    const oy = isMobile ? (parseFloat(popup.dataset.offsetYMobile) || 12) : (parseFloat(popup.dataset.offsetY) || 24);
    popup.style.bottom = pos.startsWith('bottom') ? oy + 'px' : 'auto';
    popup.style.top    = pos.startsWith('top')    ? oy + 'px' : 'auto';
    popup.style.left   = pos.endsWith('left')     ? ox + 'px' : 'auto';
    popup.style.right  = pos.endsWith('right')    ? ox + 'px' : 'auto';
  }
  applyPosition();
  window.addEventListener('resize', applyPosition);

  // ── Shuffle ───────────────────────────────────────────────────────
  if (cfg.shuffle) {
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
  }

  // ── DOM refs ──────────────────────────────────────────────────────
  const closeBtn = document.getElementById('SocialProofClose');
  const linkEl   = document.getElementById('SocialProofLink');
  const avatarEl = document.getElementById('SocialProofAvatar');
  const line1El  = document.getElementById('SocialProofLine1');
  const line2El  = document.getElementById('SocialProofLine2');

  // ── State ─────────────────────────────────────────────────────────
  let idx       = 0;
  let cycles    = 0;
  let isHovered = false;
  let isActive  = false;
  let hideTimer = null;
  let nextTimer = null;

  function randTime() {
    const mins = Math.floor(Math.random() * (cfg.timeMax - cfg.timeMin + 1)) + cfg.timeMin;
    return mins === 1 ? '1 min ago' : `${mins} mins ago`;
  }

  function show(item) {
    if (sessionStorage.getItem('sp-closed') === '1') return;

    // Link
    linkEl.href = item.url && item.url !== '#' ? item.url : '#';
    linkEl.style.cursor = (item.url && item.url !== '#') ? 'pointer' : 'default';

    // Avatar
    if (item.image) {
      avatarEl.innerHTML = `<img src="${item.image}" alt="${item.name || ''}" loading="lazy">`;
    } else {
      avatarEl.innerHTML = `<span>🛍️</span>`;
    }

    // Lines
    const flag     = item.flag     ? `${item.flag} ` : '';
    const location = item.location ? ` · ${item.location}` : '';
    const time     = cfg.dynamicTime ? randTime() : (item.time || '');

    const actionMap = {
      purchased:  'purchased',
      downloaded: 'downloaded for free',
      claimed:    'claimed',
      unlocked:   'unlocked',
      got:        'got'
    };
    const verb = actionMap[item.action] || 'purchased';

    line1El.innerHTML = `<strong>${item.name || ''}</strong> ${verb}`;
    line2El.innerHTML = `<span class="sp-product">${item.product || ''}</span>`
      + (time ? ` · ${time}` : '')
      + (item.location ? `<br><span class="sp-loc">${flag}${item.location}</span>` : '');

    // Animate in
    popup.classList.remove('sp-out');
    popup.classList.add('sp-in');
    isActive = true;

    clearTimeout(hideTimer);
    if (!isHovered) {
      hideTimer = setTimeout(hide, cfg.visibleMs);
    }
  }

  function hide() {
    if (!isActive) return;
    popup.classList.remove('sp-in');
    popup.classList.add('sp-out');
    isActive = false;
    nextTimer = setTimeout(next, 500 + cfg.intervalMs);
  }

  function next() {
    idx++;
    if (idx >= items.length) {
      idx = 0;
      cycles++;
      if (cfg.maxCycles > 0 && cycles >= cfg.maxCycles) return; // stop
      if (!cfg.loop) return;
      // Re-shuffle next round
      if (cfg.shuffle) {
        for (let i = items.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [items[i], items[j]] = [items[j], items[i]];
        }
      }
    }
    if (isHovered) {
      nextTimer = setTimeout(next, 1000);
    } else {
      show(items[idx]);
    }
  }

  // ── Close button ──────────────────────────────────────────────────
  closeBtn && closeBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    sessionStorage.setItem('sp-closed', '1');
    clearTimeout(hideTimer);
    clearTimeout(nextTimer);
    popup.classList.remove('sp-in');
    popup.classList.add('sp-out');
    isActive = false;
  });

  // ── Hover pause ───────────────────────────────────────────────────
  popup.addEventListener('mouseenter', function () {
    isHovered = true;
    if (isActive) clearTimeout(hideTimer);
  });
  popup.addEventListener('mouseleave', function () {
    isHovered = false;
    if (isActive) hideTimer = setTimeout(hide, cfg.visibleMs);
  });

  // ── Kick off ──────────────────────────────────────────────────────
  nextTimer = setTimeout(function () { show(items[0]); }, cfg.initialMs);
});
